import type { AdminKpisPdfMetricProps } from "../../models/admin-kpis.models";
import { memo } from "react";

const AdminKpisPdfMetric = ({ metric }: AdminKpisPdfMetricProps) => {
  return (
    <div className="admin-kpis-print-metric">
      <div className="admin-kpis-print-metric-label">{metric.label}</div>
      <div className="admin-kpis-print-metric-value">{metric.percentage.toFixed(1)}%</div>
      <div className="admin-kpis-print-metric-count">{metric.count} vessels</div>
    </div>
  );
};

export default memo(AdminKpisPdfMetric);
